import { useState } from "react";
import { ChevronDown, Home, HardHat, HelpCircle } from "lucide-react";

const ICONS = { Home, HardHat, HelpCircle };

function AccordionItem({ question, answer }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-slate-100 last:border-0">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between py-4 px-1 text-left hover:bg-slate-50/50 transition-colors"
        data-testid={`faq-q-${question.substring(0, 20).replace(/\s/g, '-').toLowerCase()}`}
      >
        <span className="font-medium text-[#0B1F3B] text-sm pr-4">{question}</span>
        <ChevronDown className={`w-4 h-4 text-slate-400 flex-shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="pb-4 px-1">
          <p className="text-sm text-slate-600 leading-relaxed">{answer}</p>
        </div>
      )}
    </div>
  );
}

export default function FAQSection({ category, color, iconName, items }) {
  const IconComponent = ICONS[iconName] || HelpCircle;
  const testId = `faq-section-${category.replace(/\s/g, '-').toLowerCase()}`;
  return (
    <div className="mb-10" data-testid={testId}>
      <div className="flex items-center gap-3 mb-4">
        <div className={`w-10 h-10 rounded-lg ${color} flex items-center justify-center`}>
          <IconComponent className="w-5 h-5" />
        </div>
        <h2 className="text-lg font-bold text-[#0B1F3B]">{category}</h2>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 px-5">
        {items.map(({ q, a }) => (
          <AccordionItem key={q} question={q} answer={a} />
        ))}
      </div>
    </div>
  );
}
